import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Box } from "../../Box/index.js";
import { Typography } from "../../Typography/index.js";
import { Tooltip } from "../../Tooltip/index.js";
import { scaleBarInputConfigs } from "./ScaleBarInput.configs.js";
const SCALE_BAR_ELEMENTS_COUNT = 5;
const getConfig = (value, target)=>{
    let type;
    type = value < target ? 'low' : value === target ? 'normal' : 'high';
    return scaleBarInputConfigs[type];
};
const ScaleBarInput = (t0)=>{
    const $ = c(23);
    const { target: t1, value: t2, renderTooltip, size: t3, color: t4, onChange, showLabel: t5, disabled } = t0;
    const target = void 0 === t1 ? 0 : t1;
    const value = void 0 === t2 ? 0 : t2;
    const size = void 0 === t3 ? "md" : t3;
    const color = void 0 === t4 ? "text" : t4;
    const showLabel = void 0 === t5 ? true : t5;
    let t6;
    if ($[0] !== target || $[1] !== value) {
        t6 = getConfig(value, target);
        $[0] = target;
        $[1] = value;
        $[2] = t6;
    } else t6 = $[2];
    const config = t6;
    let t7;
    if ($[3] !== disabled || $[4] !== onChange) {
        t7 = (i)=>{
            if (disabled) return;
            null == onChange || onChange(i);
        };
        $[3] = disabled;
        $[4] = onChange;
        $[5] = t7;
    } else t7 = $[5];
    const handleChange = t7;
    let t8;
    if ($[6] !== config || $[7] !== showLabel) {
        t8 = showLabel && /*#__PURE__*/ jsx(Box, {
            children: /*#__PURE__*/ jsx(Typography, {
                variant: "caption",
                color: config.text.color,
                children: config.text.label
            })
        });
        $[6] = config;
        $[7] = showLabel;
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== color || $[10] !== config || $[11] !== disabled || $[12] !== handleChange || $[13] !== onChange || $[14] !== renderTooltip || $[15] !== size || $[16] !== value) {
        t9 = new Array(SCALE_BAR_ELEMENTS_COUNT).fill(null).map((_, index)=>{
            const tooltip = null == renderTooltip ? void 0 : renderTooltip(index);
            const colorCell = "stroke" === color ? config.level.strokeColor : config.level.color;
            return /*#__PURE__*/ jsx(Tooltip, {
                disabled: !tooltip,
                title: tooltip || "",
                placement: "bottom",
                children: /*#__PURE__*/ jsx(Box, {
                    display: "flex",
                    flexGrow: 1,
                    height: "md" === size ? 8 : 4,
                    radius: "m",
                    bgcolor: index < value ? colorCell : "stroke.primary",
                    onClick: ()=>handleChange(index + 1),
                    cursor: onChange && !disabled ? "pointer" : "default"
                }, index)
            }, index);
        });
        $[9] = color;
        $[10] = config;
        $[11] = disabled;
        $[12] = handleChange;
        $[13] = onChange;
        $[14] = renderTooltip;
        $[15] = size;
        $[16] = value;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== t9) {
        t10 = /*#__PURE__*/ jsx(Box, {
            display: "flex",
            alignItems: "center",
            gap: "4",
            children: t9
        });
        $[18] = t9;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== t10 || $[21] !== t8) {
        t11 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            flexDirection: "column",
            gap: "8",
            width: "100%",
            children: [
                t8,
                t10
            ]
        });
        $[20] = t10;
        $[21] = t8;
        $[22] = t11;
    } else t11 = $[22];
    return t11;
};
export { ScaleBarInput };
